// Redirect user back to the product or collection page they visited before logging in
// Redirect user back to the product page if they came to the login page from the checkout page

console.log("tim.js Loaded");

document.addEventListener("DOMContentLoaded", function () {
  let referrer = document.referrer;
  let currentPage = window.location.pathname;
  let domain = window.location.hostname;
  
  //if once user logged in set 'flexylogin_order_id_flow' so it also kind of signal that user has account or prior purchase
  if(window.customerLoggedIn){
    if(!localStorage.getItem("flexylogin_order_id_flow")){
      localStorage.setItem("flexylogin_order_id_flow","1");
    }
  }

  const priorPurchase = localStorage.getItem("flexylogin_order_id_flow");

  const stikcyBtn = document.querySelector('.sticky-subscription-button');
  if (stikcyBtn) {
    // Add a click event listener to the checkout link
    stikcyBtn.addEventListener("click", function (e) {
      //if the browser signs us to prior purchase then always to login page
      if (priorPurchase && !window.customerLoggedIn) {
        e.preventDefault();
        window.location.href = "/account/login";
      }
    });
  }

  const memebrshipBtn = document.querySelector('.member_ship');
  if (memebrshipBtn) {
    // Add a click event listener to the checkout link
    memebrshipBtn.addEventListener("click", function (e) {
      if (priorPurchase && !window.customerLoggedIn) {
        e.preventDefault();
        window.location.href = "/account/login";
      }
    });
  }

  function waitForCheckoutLink(attempts = 0, maxAttempts = 50) {
    const checkoutLink = document.querySelector('.appstle_membership_blocker_wrapper > a');
    if (checkoutLink) {
      checkoutLink.addEventListener("click", function (e) {
        if (priorPurchase && !window.customerLoggedIn) {
          e.preventDefault();
          window.location.href = "/account/login";
        }
      });
    } else if (attempts < maxAttempts) {
      setTimeout(() => waitForCheckoutLink(attempts + 1, maxAttempts), 200);
    } else {
      console.log('Élément non trouvé après', maxAttempts, 'tentatives');
    }
  }
  waitForCheckoutLink();

// Utility to append hidden input to login form
function appendReturnToInput(value, loginForm) {
  const input = document.createElement("input");
  input.type = "hidden";
  input.name = "return_to";
  input.value = value;
  loginForm.appendChild(input);
}

// Utility to remove checkout_url input if exists
function delCheckoutInput(loginForm) {
  const input = loginForm.querySelector('input[name="checkout_url"]');
  if (input) {
    input.remove();
  } else {
  }
}

  if (currentPage !== "/account/login" || !referrer) {
    return;
  }
  if(!passwordErrorPresent == true){
      localStorage.setItem(
      "postLoginRedirectFromCheckout_standalone",
      JSON.stringify({ referrer, currentPage, domain }) 
    );
  }


  //if the user enters wrong password the form also rember constraints
  let oldConstraints = localStorage.getItem("postLoginRedirectFromCheckout_standalone");
  if (!oldConstraints) {
    localStorage.setItem(
      "postLoginRedirectFromCheckout_standalone",
      JSON.stringify({ referrer, currentPage, domain }) 
    );
  } else {
    let oldConstraintsObj = JSON.parse(oldConstraints);
    // Load referrer, currentPage, and domain from the stored object
    ({ referrer, currentPage, domain } = oldConstraintsObj);
  }
  try {
    const refUrl = new URL(referrer);

    if (refUrl.hostname !== domain) {
      return;
    }

    if (refUrl.pathname === "/account/login") {
      return;
    }

    const loginForm = document.querySelector('form[action="/account/login"]');
    if (!loginForm) {
      return;
    }

    const refPath = refUrl.pathname.toLowerCase();
    const storedPath = localStorage.getItem("postLoginRedirectFromCheckout_standalone");

    if (storedPath && storedPath.startsWith("/products/")) {
      appendReturnToInput(storedPath, loginForm);
      delCheckoutInput(loginForm);
      localStorage.removeItem("postLoginRedirectFromCheckout_standalone"); // clear after use
      return;
    }

    // Otherwise fallback to referrer if product or collection page
    const isProductOrCollection =
      refPath.startsWith("/products/") || refPath.startsWith("/collections/");

    if (isProductOrCollection) {
      const returnPath = refUrl.pathname + refUrl.search;

      appendReturnToInput(returnPath, loginForm);
    }
  } catch (err) {
    alert("Error processing login redirection: " + err.message);
  }
});
